import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { Section, Cell, SegmentedControl } from '@telegram-apps/telegram-ui'

import { api } from '../../lib/api'
import type { Stats } from '../../lib/types'
import PageHeader from '../../components/PageHeader'
import { SkeletonList } from '../../components/Skeleton'

type Period = 'month' | 'quarter' | 'year' | 'all'

export default function SecretaryStats() {
  const [period, setPeriod] = useState<Period>('month')
  const { data, isLoading } = useQuery<Stats>({
    queryKey: ['stats', period],
    queryFn: () => api.get<Stats>(`/stats?period=${period}`),
  })

  return (
    <>
      <PageHeader title="Ваша работа" />

      <div style={{ padding: '0 16px 8px' }}>
        <SegmentedControl>
          <SegmentedControl.Item selected={period === 'month'} onClick={() => setPeriod('month')}>Месяц</SegmentedControl.Item>
          <SegmentedControl.Item selected={period === 'quarter'} onClick={() => setPeriod('quarter')}>Квартал</SegmentedControl.Item>
          <SegmentedControl.Item selected={period === 'year'} onClick={() => setPeriod('year')}>Год</SegmentedControl.Item>
          <SegmentedControl.Item selected={period === 'all'} onClick={() => setPeriod('all')}>Всё</SegmentedControl.Item>
        </SegmentedControl>
      </div>

      {isLoading || !data ? (
        <SkeletonList count={4} />
      ) : (
        <>
          <Section header="Цифры">
            <Cell subtitle="Выполнено">{data.done}</Cell>
            <Cell subtitle="В работе">{data.pending}</Cell>
            <Cell subtitle="Просрочено">{data.overdue}</Cell>
            <Cell subtitle="Средний срок выполнения">
              {data.avg_completion_days != null ? `${data.avg_completion_days} дня` : '—'}
            </Cell>
            <Cell subtitle="В срок">{data.on_time_percent}%</Cell>
          </Section>

          <Section header="По типам">
            <Cell subtitle="Рабочих">💼 {data.work}</Cell>
            <Cell subtitle="Личных">🏠 {data.personal}</Cell>
          </Section>
        </>
      )}
    </>
  )
}
